<template>
  <el-dialog title="批量录入" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
    <el-input
        type="textarea"
        :rows="10"
        placeholder="请输入学生名单（可直接粘贴微信接龙的形式），每行一个或多个学生，支持带干扰字符。
录入的名单将在本页面批量标记为已完成"
        v-model="inputText"
        style="width: 100%; white-space: pre-line;">
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取 消</el-button>
      <el-button type="primary" @click="handleProcess">{{ confirmButtonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ImportStudentsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    isAssigned: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    inputText: {
      get() {
        return this.text
      },
      set(val) {
        this.$emit('update:text', val)
      }
    },
    confirmButtonText() {
      return this.isAssigned ? '确 定' : '确定并布置'
    }
  },
  methods: {
    handleProcess() {
      this.$emit('process')
    }
  }
}
</script>